/* eslint-disable react/display-name */
import React, {useRef, useState} from 'react';
import {Button, Modal, PageHeader, Table, Tabs} from 'antd';
import {useAsyncRetry} from 'react-use';

import useTitle from '@/hook/useTitle';
import {DeleteOutlined, DownOutlined, EditOutlined} from '@/icons';
import AppTagFormModal from './AppTagFormModal';
import {deleteAppTag, getAllAppTags, getAppTags} from '@/api/apptag';
import {RowAction} from '@/component';

const {TabPane} = Tabs;

function AppTagPage() {
    useTitle('应用标签 - 系统管理');

    const appTagFormModalRef = useRef();
    const [type, setType] = useState('1');
    const {value, loading, retry} = useAsyncRetry(() => {
        if (type == '1') {
            return getAllAppTags();
        } else {
            return getAppTags(null, 2);
        }
    });

    function onAddClick(adType) {
        return () => {
            onAddByAdTypeClick(adType);
        };
    }

    function onAddByAdTypeClick(adType) {
        appTagFormModalRef.current.showModal({adType});
    }

    function onModifyClick(record) {
        console.log(record);
        appTagFormModalRef.current.showModal(record);
    }

    function onDeleteClick(record) {
        console.log(record);
        Modal.confirm({
            title: '警告',
            content: `确定删除「${record.name}」`,
            okButtonProps: {danger: true},
            onOk: () => {
                deleteAppTag(record.id).then(() => {
                    retry();
                });
            },
        });
    }

    const extra = (
        <>
            {/*<Button type="primary" onClick={onAddClick(1)}>*/}
            {/*    添加 AD 应用标签*/}
            {/*</Button>*/}
            <Button type="primary" onClick={onAddClick(2)}>
                添加 AD 非应用标签
            </Button>
        </>
    );

    const actions = [
        {
            key: 'modify',
            title: '修改',
            icon: <EditOutlined />,
            onClick: onModifyClick,
        },
        {
            key: 'delete',
            title: '删除',
            icon: <DeleteOutlined />,
            onClick: onDeleteClick,
        },
    ];
    const columnsA = [
        {
            title: '标签',
            dataIndex: 'name',
            width: 150,
        },
        {
            title: '所属应用',
            dataIndex: 'appName',
            width: 150,
        },
        {
            title: '标签类别',
            dataIndex: 'tagGroup',
            width: 120,
            render: (tagGroup, record) => {
                const {adType} = record;
                if (adType === 2) {
                    return '';
                }

                return (
                    <>
                        {tagGroup === 0 && '用户可见范围组'}
                        {tagGroup === 1 && '应用管理员组'}
                    </>
                );
            },
        },
        {
            title: 'AD Group Id',
            dataIndex: 'groupId',
            width: 410,
        },
        {
            title: '操作',
            key: 'action',
            width: 120,

            // eslint-disable-next-line react/display-name
            render: (__, record) => <RowAction actions={actions} record={record} />,
        },
    ];

    const columnsB = [
        {
            title: '标签',
            dataIndex: 'name',
        },
        {
            title: 'AD Group Id',
            dataIndex: 'groupId',
        },
        {
            title: '操作',
            key: 'action',
            width: 150,

            // eslint-disable-next-line react/display-name
            render: (__, record) => <RowAction actions={actions} record={record} />,
        },
    ];

    let columns = type == '1' ? columnsA : columnsB;

    function callback(key) {
        console.log(key);
        setType(key);
        retry();
        // getAppTags(null, parseInt(key)).then(res => {
        //     console.log(res);
        // });
    }

    return (
        <PageHeader
            title={type == '1' ? `AD 应用标签` : 'AD 非应用标签'}
            extra={extra}
            style={{overflowY: 'auto'}}
        >
            <Tabs activeKey={type} onChange={callback}>
                <TabPane tab="AD 应用标签" key="1">
                    <Table
                        rowKey="id"
                        dataSource={value?.data}
                        columns={columns}
                        pagination={false}
                    />
                </TabPane>
                <TabPane tab="AD 非应用标签" key="2">
                    <Table
                        rowKey="id"
                        dataSource={value?.data}
                        columns={columns}
                        pagination={false}
                    />
                </TabPane>
            </Tabs>

            <AppTagFormModal ref={appTagFormModalRef} reload={retry} />
        </PageHeader>
    );
}

export default AppTagPage;
